import { AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, DoCheck, ElementRef, OnChanges, OnDestroy, OnInit, ViewChild, afterNextRender} from '@angular/core';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss'
})
export class TestComponent implements
OnInit, DoCheck,
AfterContentInit, AfterContentChecked,
AfterViewInit, AfterViewChecked,
OnDestroy { 

  @ViewChild('content') contentRef!: ElementRef;
   ngOnInit(): void {
    console.log("INIT called");
  }

  // Beware! Called frequently!
  // Called in every change detection cycle anywhere on the page
  ngDoCheck() { console.log('DoCheck'); }

  ngAfterContentInit() { console.log('AfterContentInit');  }

  // Beware! Called frequently!
  // Called in every change detection cycle anywhere on the page
  ngAfterContentChecked() { console.log('AfterContentChecked'); }

  ngAfterViewInit() {
    
    console.log('AfterViewInit'); 
    console.log(this.contentRef); 
  
  }

  // Beware! Called frequently!
  // Called in every change detection cycle anywhere on the page
  ngAfterViewChecked() { console.log('AfterViewChecked'); }

  ngOnDestroy() { console.log('OnDestroy'); }

}
